import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // Create a CSS file for footer styles

const Footer = () => {
  return (
    <footer className="footer">
      <ul className="footer-links">
        <li><Link to="/about-us">About Us</Link></li>
        <li><Link to="/terms">Terms of Use</Link></li>
        <li><Link to="/contact-us">Contact Us & Support</Link></li>
        <li><Link to="/faqs">FAQs</Link></li>
      </ul>
    </footer>
  );
};

export default Footer;
